module.exports = __webpack_public_path__ + "img/logo_dorapp--or.3500efc3.svg";